/** Capture anchor at the event boundary; React may run the updater later. */
export function selectWorkers(previous, { workerId, shiftKey, anchor, index, visible }) {
  const next = new Set(previous);
  if (shiftKey && anchor !== null && index >= 0) {
    visible.slice(Math.min(anchor, index), Math.max(anchor, index) + 1).forEach(w => next.add(w.Id ?? w.id));
  } else if (next.has(workerId)) next.delete(workerId); else next.add(workerId);
  return next;
}
